export default {
  appLoading: "Chargement de l'interface de recherche en cours",
  added: 'aucun produit | 1 produit ajouté | {count} produits ajoutés',
  variant_added: 'La référence {sku} a été ajoutée au devis.',
  application: 'Application',
  back_to_search: 'Retour à la recherche',
  category: 'Catégorie | Catégories',
  certification: 'Certification',
  certification_ab: 'Cert.',
  clone: 'Clone',
  conseil: 'Conseil',
  couleur: 'Couleur',
  compare: 'comparer',
  compare_limit_reached_title: "Impossible de comparer d'autres produits",
  compare_limit_reached: '{max} produits maximum !',
  'comparedProductListBar.title':
    'Aucun produit sélectionné | Produit sélectionné | Produits sélectionnés',
  conjugué: 'Conjugué',
  dilution: 'Dilution',
  dilution_ab: 'Dil.',
  filter_by: 'Filtrer par',
  format: 'Format',
  highlight_differences: 'Montrer les différences',
  hôte: 'Hôte',
  immunogène: 'Immunogène',
  isotype: 'Isotype',
  localisation: 'Localisation',
  no_product_found: 'Aucun produit ne correspond à votre recherche.',
  'predicted reactivity': 'Réactivité prédite',
  pathologie: 'Pathologie',
  presentation: 'Conditionnement',
  presentation_ab: 'Cond.',
  price: 'Prix',
  product: 'produit | produits',
  products_title: 'aucun produit trouvé | 1 produit trouvé | {count} produits trouvés',
  products_compared: '{number} produits sélectionnés',
  purification: 'Purification',
  quantity: 'Quantité',
  quantity_ab: 'Qté.',
  reactivity: 'Réactivité',
  réactivité: 'Réactivité',
  reference: 'Référence',
  reference_ab: 'Réf.',
  reinit: 'Réinitialiser',
  search_in_progress: 'Recherche en cours',
  search_result: 'Résultat de votre recherche : ',
  spécificité: 'Spécificité',
  suggested_products: 'Suggestions de produits',
  supplier: 'Fournisseur',
  taille: 'Taille',
  'tissus controles': 'Tissus controles',
  to_cart: 'au panier',
  vendor: 'Fournisseur',
  vendor_ab: 'Four.',
  voir_moins: 'Voir moins',
  voir_plus: 'Voir plus',
};
